import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import DropdownButton from '../DropdownButton';

import type { ResourceType } from './types';

import styles from './SavedResource.module.less';

//  Represents one of the dropdown items.
export type ResourceOption = {
  id: number | null;
  name: string;
  isProtected?: boolean;
};

type Props = {
  resourceType: ResourceType;
  resources: ResourceOption[];
  currentResource: ResourceOption;
  isLoading: boolean;
  /**
   * Whether to hide the id of the resource in the dropdown. Useful for resources that need to be identified by users
   * in the CLI by ID, such as saved issue filters.
   */
  shouldHideId?: boolean;
  onChange: (resource: ResourceOption['id']) => void;
};

/**
 * SavedResourceDropdownList renders the list of saved resources
 * for a given resource type.
 */
export const SavedResourceDropdownList: VoidFunctionComponent<Props> = ({
  resourceType,
  resources,
  currentResource,
  isLoading,
  shouldHideId,
  onChange,
}) => (
  <DropdownButton
    className={styles.savedResourceDropdown}
    id={`saved-${resourceType}-list-dropdown`}
    title={isLoading ? 'Loading...' : <span className="dropdown-button-text">{currentResource.name}</span>}
    size="large"
    onSelect={(e) => onChange(e as number)}
    testId={`saved-${resourceType}-list-dropdown`}
    isFullWidth
  >
    {resources.map(({ id, name }) => (
      <DropdownButton.Item
        key={id}
        eventKey={id}
        className={cx({
          'fossa-dropdown-button__item--selected': currentResource.id === id,
        })}
      >
        <span className="fossa-dropdown-button__item__name">{name}</span>
        {!shouldHideId && id && <span>(id: {id})</span>}
      </DropdownButton.Item>
    ))}
  </DropdownButton>
);
